import { Injectable } from '@angular/core';

import { SessionStorageService } from '../../../../core/services/web-storage';
import { ClienteFilter } from './cliente-filter';
import { ClienteFilterStorage } from './cliente-filter-storage';

/**
 * Service utilizado para armazenar os dados do filter da carteira de clientes no session storage do navegador
 */
@Injectable({
    providedIn: 'root'
})
export class ClienteFilterStorageService {
    private key = 'clienteFilter';

    constructor(private sessionStorageService: SessionStorageService) { }


    /** Obtem os dados do filtro armazenados */
    get(): ClienteFilterStorage {
        const data = this.sessionStorageService.getObject(this.key) as ClienteFilterStorage;
        if (data) {
            // Criando um Map com os campos filtrados e seus respectivos valores
            data.filterValues = new Map();
            const keys = Object.keys(data.filter);
            keys.forEach(key => data.filterValues.set(key, data.filter[key]));
        }

        return data;
    }

    /** Armazena os dados do filtro */
    set(filter: ClienteFilter) {
        const data = new ClienteFilterStorage(filter);
        this.sessionStorageService.setObject(this.key, data);
    }

    /** Remove os dados do filtro */
    remove() {
        this.sessionStorageService.remove(this.key);
    }

    /** Verifica se possui filtro salvo no storage */
    hasFilter(): boolean {
        const filter = this.get();
        return filter != null && filter !== undefined;
    }

    /** Aplica o filtro armazenado no objeto do filtro informado */
    applyFilter(filter: { [key: string]: any }) {
        const filterStorage = this.get();
        if (filterStorage != null) {
            // Se possuir os dados, então setamos o filtro com os seus valores armazenados
            if (filter) {
                filterStorage.filterValues.forEach((value, key) => filter[key] = value);
            }
        }
    }
}
